import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router';
import ServiceImage from '../../static/images/ServiceUnavailable.png';

class ServiceUnavailable extends Component {
  render() {
    const { t } = this.props;
    return (
      <div className="service-container">
        <div className="item">
          <img src={ServiceImage} alt={t('common.error.serviceNotApplied')} />
          <p className="title">{t('common.error.serviceNotApplied')}</p>
        </div>
      </div>
    );
  }
}

export default withRouter(withTranslation()(ServiceUnavailable));
